import React from 'react';
import { Route } from 'react-router';

import { ROUTES } from '../../../../core/router/routes';
import MultimediaAdd from '../../../../features/multimedia/MultimediaAdd';
import MultimediaList from '../../../../features/multimedia/MultimediaList';
import MultimediaEdit from '../../MultimediaEdit';

const MultimediaRoute = () => [
  <Route path={ROUTES.MULTIMEDIA.ADD} key={ROUTES.MULTIMEDIA.ADD} component={MultimediaAdd} />,
  <Route path={ROUTES.MULTIMEDIA.EDIT} key={ROUTES.MULTIMEDIA.EDIT} component={MultimediaEdit} />,
  <Route path={ROUTES.MULTIMEDIA.LIST} key={ROUTES.MULTIMEDIA.LIST} component={MultimediaList} />,
];

export default MultimediaRoute;
